import { FETCH_REVERSED_TRANSACTION_FAILURE, FETCH_REVERSED_TRANSACTION_START, FETCH_REVERSED_TRANSACTION_SUCCESS, FETCH_WALLET_HISTORY_SUCCESS, GET_TRANSACTION_HISTORY_FAILED, GET_TRANSACTION_HISTORY_START, GET_TRANSACTION_HISTORY_SUCCESS } from "./ActionConstant";
import { FETCH_INCOME_WALLET_HISTORY_START } from "./ActionConstant";
import { FETCH_EARNING_SUMMARY_SUCCESS } from "./ActionConstant";
import { FETCH_EARNING_SUMMARY_FAILURE } from "./ActionConstant";
import { FETCH_EARNING_SUMMARY_START } from "./ActionConstant";
import { FETCH_WALLET_HISTORY_FAILURE } from "./ActionConstant";
import { FETCH_WALLET_HISTORY_START } from "./ActionConstant";
import {
  FETCH_WALLET_DETAILS_START,
  FETCH_WALLET_DETAILS_SUCCESS,
  FETCH_WALLET_DETAILS_FAILURE,
  ADD_MONEY_VIA_CARD_START,
  ADD_MONEY_VIA_CARD_SUCCESS,
  ADD_MONEY_VIA_CARD_FAILURE,
} from "./ActionConstant";

// Get Wallet Details actions.

export function fetchWalletDetailsStart(data) {
  return {
    type: FETCH_WALLET_DETAILS_START,
    data,
  };
}

export function fetchWalletDetailsSuccess(data) {
  return {
    type: FETCH_WALLET_DETAILS_SUCCESS,
    data,
  };
}

export function fetchWalletDetailsFailure(error) {
  return {
    type: FETCH_WALLET_DETAILS_FAILURE,
    error,
  };
}

// add Wallet via card actions.

export function addMoneyViaCardStart(data) {
  return {
    type: ADD_MONEY_VIA_CARD_START,
    data,
  };
}

export function addMoneyViaCardSuccess(data) {
  return {
    type: ADD_MONEY_VIA_CARD_SUCCESS,
    data,
  };
}

export function addMoneyViaCardFailure(error) {
  return {
    type: ADD_MONEY_VIA_CARD_FAILURE,
    error,
  };
}

//fetch wallet history
export function fetchWalletHistoryStart() {
  return {
    type: FETCH_WALLET_HISTORY_START,
  };
}

export function fetchIncomeWalletHistoryStart() {
  return {
    type: FETCH_INCOME_WALLET_HISTORY_START,
  };
}

export function fetchWalletHistorySuccess(data) {
  return {
    type: FETCH_WALLET_HISTORY_SUCCESS,
    data,
  };
}

export function fetchWalletHistoryFailure(error) {
  return {
    type: FETCH_WALLET_HISTORY_FAILURE,
    error,
  };
}

export function fetchEarningSummaryStart() {
  return {
    type: FETCH_EARNING_SUMMARY_START,
  };
}

export function fetchEarningSummarySuccess(data) {
  return {
    type: FETCH_EARNING_SUMMARY_SUCCESS,
    data,
  };
}

export function fetchEarningSummaryFailture(error) {
  return {
    type: FETCH_EARNING_SUMMARY_FAILURE,
    error,
  };
}

export function fetchReversedTransactionStart() {
  return {
    type: FETCH_REVERSED_TRANSACTION_START,
  };
}

export function fetchReversedTransactionSuccess(data) {
  return {
    type: FETCH_REVERSED_TRANSACTION_SUCCESS,
    data,
  };
}

export function fetchReversedTransactionFailure(error) {
  return {
    type: FETCH_REVERSED_TRANSACTION_FAILURE,
    error,
  };
}

export function fetchTransactionHistory(payload) {
  return {
    type: GET_TRANSACTION_HISTORY_START,
    payload,
  }
}

export function fetchTransactionHistorySuccess(payload) {
  return {
    type: GET_TRANSACTION_HISTORY_SUCCESS,
    payload,
  }
}

export function fetchTransactionHistoryFailure(payload) {
  return {
    type: GET_TRANSACTION_HISTORY_FAILED,
    payload,
  }
}
